import AdminAddDashboardsSubarea from '@src/main/ui/components/AdminAddDashboards/AdminAddDashboardsSubarea';
import { type FC } from 'react';

const AdminAddDashboardsSubareaPage: FC = () => <AdminAddDashboardsSubarea />;

export default AdminAddDashboardsSubareaPage;
